import urls from "../urls";
import { callGetApi } from "../callApi";
import objectToQueryString from "@/utils";
// import objectToQueryString from "@/utils/objectToGetParams";

const locationService = {
  getState: async () => {
    const states = await callGetApi(urls.GET_STATE);
    if(states.data)
    states.data = states.data.map((state: {label:string}) => {
      state["label"] = capitalizeFirstLetter(state["label"]);
      return state;
    });
    return states;
  },

  getCity: async (state: string) => {

    const city = await callGetApi(
      urls.GET_CITY + objectToQueryString({ stateId : state })
    );
    if(city.data)
    city.data = city.data.map((data: { [x: string]: string; }) => {
      data["label"] = capitalizeFirstLetter(data["label"]);
      return data;
    });
    return city;
  },

  // getLocationByQuery: async (body: object) => {
  //   const result = await callGetApi(
  //     urls.GET_BY_QUERY + objectToQueryString(JSON.parse(JSON.stringify(body)))
  //   );
  //   result.data = result.data.map((location: unknown) => {
  //     if (location["city"])
  //       location["city"] = capitalizeFirstLetter(location["city"]);
  //     location["state"] = capitalizeFirstLetter(location["state"]);
  //     return location;
  //   });
  //   return result;
  // },
};

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default locationService;
